import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// A per-tab sessionStorage token (used by impersonation tabs) takes precedence
// over the shared localStorage token, so a backdoor-login tab never disturbs the
// admin/reseller's own tab.
export function getStoredToken() {
  return sessionStorage.getItem("wa_token") || localStorage.getItem("wa_token");
}
export function clearStoredToken() {
  if (sessionStorage.getItem("wa_token")) sessionStorage.removeItem("wa_token");
  else localStorage.removeItem("wa_token");
}

// Backdoor login: mint a full-access token for the target account and open it in a
// NEW tab. The token is passed via the URL hash (never sent to the server/logs).
export async function openImpersonation(tenantId) {
  const { data } = await api.post("/auth/impersonate", { target_tenant_id: tenantId });
  const url = `${window.location.origin}/impersonate#t=${encodeURIComponent(data.access_token)}`;
  window.open(url, "_blank", "noopener");
  return data.target;
}

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && getStoredToken()) {
      clearStoredToken();
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function money(minor, currency = "USD") {
  const v = (Number(minor || 0) / 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `$${v}`;
}

export default api;
